import { formatiereGehzeit } from '../domain/einheiten'
export interface RoutePOI {
  id: number
  name: string
  description: string | null
  type: 'manual' | 'screen_point'
  km: number
}

export interface ElevationPoint {
  km: number
  alt: number
}

export interface Route {
  id: number
  name: string
  subtitle: string
  shortDesc: string
  color: string
  totalKm: number
  poiCount: number
  highlights: string[]
  pois: RoutePOI[]
  elevation: ElevationPoint[]
}

import { getConfig } from '../config/project'

/** @deprecated Use getConfig().api.trackId instead */
export const TRACK_ID = getConfig().api.trackId
export const TRACK_NAME = getConfig().name

/** Check if current project has static route data */
export function hasStaticRoutes(): boolean {
  return getConfig().id === 'tscheppa'
}

export const ROUTES: Route[] = [
  {
    id: 56,
    name: 'Tschaukofall',
    subtitle: 'Der Pfad der Entdecker',
    shortDesc: 'Über den Tschaukofall, die Teufelsbrücke und das Felsentor zum Gasthof Deutscher Peter.',
    color: '#C4A96A',
    totalKm: 4.54,
    poiCount: 28,
    highlights: ['Tschaukofall', 'Teufelsbrücke', 'Felsentor', 'Pflanzenweg', 'Deutscher Peter'],
    pois: [
      { id: 24752, name: 'Besucherzentrum', description: 'Das moderne Portal zur Schlucht — hier beginnt das Abenteuer.', type: 'manual', km: 0 },
      { id: 24804, name: 'Parkplatz', description: null, type: 'manual', km: 0.06 },
      { id: 24699, name: 'Flying Fox', description: 'Hoch über dem Loiblbach die Schlucht überqueren — Nervenkitzel pur.', type: 'manual', km: 0.35 },
      { id: 24710, name: 'Kassa', description: 'Die Schwelle zwischen der geordneten Welt und dem wilden Herzen des Berges.', type: 'manual', km: 1.26 },
      { id: 24719, name: 'Wasserüberlauf', description: 'Der Wasserüberlauf der Quelle, die ganz Ferlach mit Trinkwasser versorgt.', type: 'manual', km: 1.88 },
      { id: 24693, name: 'Wildererplatzl', description: 'Rastplatz am Bach — wo einst Wilderer und Schmuggler unterwegs waren.', type: 'manual', km: 1.94 },
      { id: 24694, name: 'Weggabelung', description: 'Hier trennen sich die drei Routen. Rechts geht es zum Tschaukofall.', type: 'manual', km: 2.62 },
      { id: 24720, name: 'Teufelsbrücke', description: 'Eine kühne Konstruktion über der tiefen Schlucht — schwindelerregend!', type: 'manual', km: 2.95 },
      { id: 24731, name: 'Tschaukofall', description: 'Der mächtige Wasserfall — das Herzstück der Schlucht.', type: 'manual', km: 3.02 },
      { id: 24721, name: 'Felsentor', description: 'Ein Triumphbogen der Natur, über Jahrtausende vom Wasser geformt.', type: 'manual', km: 3.02 },
      { id: 24724, name: 'Elfenquelle', description: null, type: 'manual', km: 3.53 },
      { id: 24723, name: 'Liebesplatzl', description: null, type: 'manual', km: 3.92 },
      { id: 24730, name: 'Deutscher Peter', description: 'Gasthof und Ziel — Geburtsort von Dr. Peter Tschauko (1852).', type: 'manual', km: 4.45 },
    ],
    elevation: [
      { km: 0.0, alt: 632 }, { km: 0.08, alt: 630 }, { km: 0.18, alt: 635 }, { km: 0.28, alt: 635 },
      { km: 0.37, alt: 602 }, { km: 0.45, alt: 617 }, { km: 0.52, alt: 588 }, { km: 0.60, alt: 585 },
      { km: 0.80, alt: 602 }, { km: 0.91, alt: 623 }, { km: 1.05, alt: 614 }, { km: 1.28, alt: 598 },
      { km: 1.38, alt: 624 }, { km: 1.56, alt: 629 }, { km: 1.81, alt: 632 }, { km: 1.88, alt: 643 },
      { km: 2.02, alt: 642 }, { km: 2.08, alt: 642 }, { km: 2.25, alt: 700 }, { km: 2.27, alt: 722 },
      { km: 2.31, alt: 722 }, { km: 2.34, alt: 737 }, { km: 2.38, alt: 737 }, { km: 2.40, alt: 758 },
      { km: 2.53, alt: 685 }, { km: 2.59, alt: 685 }, { km: 2.62, alt: 701 }, { km: 2.70, alt: 701 },
      { km: 2.75, alt: 723 }, { km: 2.85, alt: 750 }, { km: 2.94, alt: 798 }, { km: 2.97, alt: 792 },
      { km: 3.02, alt: 792 }, { km: 3.04, alt: 792 }, { km: 3.06, alt: 788 }, { km: 3.08, alt: 788 },
      { km: 3.19, alt: 768 }, { km: 3.30, alt: 745 }, { km: 3.50, alt: 754 }, { km: 3.62, alt: 735 },
      { km: 3.81, alt: 742 }, { km: 3.88, alt: 755 }, { km: 3.97, alt: 723 }, { km: 4.22, alt: 726 },
      { km: 4.31, alt: 704 }, { km: 4.46, alt: 708 }, { km: 4.54, alt: 714 },
    ],
  },
  {
    id: 60,
    // Umgewidmet (Alex 2026-07-29): die Route heißt in ArTrack „Route Kunstweg",
    // seit zwölf Skulpturen zwischen km 2,68 und 3,01 auf ihr stehen. Das
    // Schaukraftwerk liegt weiterhin bei km 3,24 an der Strecke — es löst die
    // Kunst nicht ab, es kommt danach.
    name: 'Kunstweg',
    subtitle: 'Kunst & Wasserkraft',
    shortDesc: 'Zwölf Skulpturen im Wald, danach die Wasser-Energie-Welt zum Gasthof Deutscher Peter.',
    color: '#7CB342',
    totalKm: 3.92,
    poiCount: 17,
    highlights: ['Zwölf Skulpturen', 'Wasserkraftwerk Loibl', 'Deutscher Peter'],
    pois: [
      { id: 24752, name: 'Besucherzentrum', description: 'Das moderne Portal zur Schlucht — hier beginnt das Abenteuer.', type: 'manual', km: 0 },
      { id: 24804, name: 'Parkplatz', description: null, type: 'manual', km: 0.06 },
      { id: 24699, name: 'Flying Fox', description: 'Hoch über dem Loiblbach die Schlucht überqueren — Nervenkitzel pur.', type: 'manual', km: 0.35 },
      { id: 24710, name: 'Kassa', description: 'Die Schwelle zwischen der geordneten Welt und dem wilden Herzen des Berges.', type: 'manual', km: 1.26 },
      { id: 24719, name: 'Wasserüberlauf', description: 'Der Wasserüberlauf der Quelle, die ganz Ferlach mit Trinkwasser versorgt.', type: 'manual', km: 1.88 },
      { id: 24693, name: 'Wildererplatzl', description: 'Rastplatz am Bach — wo einst Wilderer und Schmuggler unterwegs waren.', type: 'manual', km: 1.94 },
      { id: 24694, name: 'Weggabelung', description: 'Hier trennen sich die Routen. Links geht es zum Wasserkraftwerk.', type: 'manual', km: 2.62 },
      { id: 24050, name: 'Wasserfall', description: null, type: 'manual', km: 2.84 },
      { id: 24722, name: 'Wasserkraftwerk Loibl', description: 'Die Kraft des Wassers wird hier zu Energie — Schaukraftwerk mit Turbinen.', type: 'manual', km: 3.24 },
      { id: 24730, name: 'Deutscher Peter', description: 'Gasthof und Ziel — Geburtsort von Dr. Peter Tschauko (1852).', type: 'manual', km: 3.84 },
    ],
    elevation: [
      { km: 0.0, alt: 632 }, { km: 0.08, alt: 630 }, { km: 0.18, alt: 635 }, { km: 0.28, alt: 635 },
      { km: 0.37, alt: 602 }, { km: 0.45, alt: 617 }, { km: 0.52, alt: 588 }, { km: 0.60, alt: 585 },
      { km: 0.80, alt: 602 }, { km: 0.91, alt: 623 }, { km: 1.05, alt: 614 }, { km: 1.28, alt: 598 },
      { km: 1.38, alt: 624 }, { km: 1.56, alt: 629 }, { km: 1.81, alt: 632 }, { km: 1.88, alt: 643 },
      { km: 2.02, alt: 642 }, { km: 2.08, alt: 642 }, { km: 2.25, alt: 700 }, { km: 2.27, alt: 722 },
      { km: 2.31, alt: 722 }, { km: 2.34, alt: 737 }, { km: 2.38, alt: 737 }, { km: 2.40, alt: 758 },
      { km: 2.53, alt: 685 }, { km: 2.59, alt: 685 }, { km: 2.62, alt: 701 }, { km: 2.64, alt: 701 },
      { km: 2.67, alt: 704 }, { km: 2.72, alt: 704 }, { km: 2.81, alt: 734 }, { km: 2.86, alt: 706 },
      { km: 2.95, alt: 706 }, { km: 2.99, alt: 698 }, { km: 3.04, alt: 698 }, { km: 3.09, alt: 694 },
      { km: 3.18, alt: 730 }, { km: 3.27, alt: 684 }, { km: 3.35, alt: 703 }, { km: 3.37, alt: 723 },
      { km: 3.60, alt: 726 }, { km: 3.70, alt: 704 }, { km: 3.84, alt: 708 }, { km: 3.92, alt: 714 },
    ],
  },
  {
    id: 63,
    name: 'Bodental',
    subtitle: 'Das große Abenteuer',
    shortDesc: 'Die längste Route — durch die Schlucht weiter ins Bodental zur Märchenwiese und zum Meerauge.',
    color: '#4FC3F7',
    totalKm: 6.22,
    poiCount: 22,
    highlights: ['Tschaukofall', 'Märchenwiese', 'Meerauge', 'Bodental'],
    pois: [
      { id: 24752, name: 'Besucherzentrum', description: 'Das moderne Portal zur Schlucht — hier beginnt das Abenteuer.', type: 'manual', km: 0 },
      { id: 24804, name: 'Parkplatz', description: null, type: 'manual', km: 0.06 },
      { id: 24699, name: 'Flying Fox', description: 'Hoch über dem Loiblbach die Schlucht überqueren — Nervenkitzel pur.', type: 'manual', km: 0.35 },
      { id: 24710, name: 'Kassa', description: 'Die Schwelle zwischen der geordneten Welt und dem wilden Herzen des Berges.', type: 'manual', km: 1.26 },
      { id: 24719, name: 'Wasserüberlauf', description: 'Der Wasserüberlauf der Quelle, die ganz Ferlach mit Trinkwasser versorgt.', type: 'manual', km: 1.88 },
      { id: 24693, name: 'Wildererplatzl', description: 'Rastplatz am Bach — wo einst Wilderer und Schmuggler unterwegs waren.', type: 'manual', km: 1.94 },
      { id: 24694, name: 'Weggabelung', description: 'Hier trennen sich die drei Routen.', type: 'manual', km: 2.62 },
      { id: 24720, name: 'Teufelsbrücke', description: 'Eine kühne Konstruktion über der tiefen Schlucht — schwindelerregend!', type: 'manual', km: 2.95 },
      { id: 24731, name: 'Tschaukofall', description: 'Der mächtige Wasserfall — das Herzstück der Schlucht.', type: 'manual', km: 3.02 },
      { id: 24726, name: 'Märchenwiese', description: 'Eine weite Almwiese, umrahmt von den Gipfeln der Karawanken — im Frühsommer ein Blütenmeer.', type: 'manual', km: 4.8 },
      { id: 24725, name: 'Meerauge', description: 'Ein türkisfarbener See — Überbleibsel der Eiszeit, glasklares Wasser über alten Baumstämmen.', type: 'manual', km: 5.5 },
      { id: 24705, name: 'Gasthof Sereinig', description: null, type: 'manual', km: 6.21 },
      { id: 24704, name: 'Bushaltestelle Bodental', description: null, type: 'manual', km: 6.22 },
    ],
    elevation: [
      { km: 0.0, alt: 632 }, { km: 0.18, alt: 635 }, { km: 0.37, alt: 602 }, { km: 0.52, alt: 588 },
      { km: 0.80, alt: 602 }, { km: 1.05, alt: 614 }, { km: 1.38, alt: 624 }, { km: 1.81, alt: 632 },
      { km: 2.02, alt: 642 }, { km: 2.25, alt: 700 }, { km: 2.31, alt: 722 }, { km: 2.36, alt: 737 },
      { km: 2.40, alt: 758 }, { km: 2.53, alt: 685 }, { km: 2.62, alt: 701 }, { km: 2.70, alt: 701 },
      { km: 2.85, alt: 750 }, { km: 2.94, alt: 798 }, { km: 2.97, alt: 792 }, { km: 3.02, alt: 792 },
      { km: 3.07, alt: 788 }, { km: 3.19, alt: 792 }, { km: 3.32, alt: 812 }, { km: 3.42, alt: 824 },
      { km: 3.66, alt: 876 }, { km: 3.77, alt: 867 }, { km: 3.93, alt: 852 }, { km: 4.04, alt: 857 },
      { km: 4.14, alt: 862 }, { km: 4.26, alt: 883 }, { km: 4.40, alt: 889 }, { km: 4.52, alt: 884 },
      { km: 4.59, alt: 904 }, { km: 4.66, alt: 904 }, { km: 4.80, alt: 926 }, { km: 4.86, alt: 927 },
      { km: 4.97, alt: 949 }, { km: 5.10, alt: 967 }, { km: 5.18, alt: 946 }, { km: 5.29, alt: 956 },
      { km: 5.52, alt: 981 }, { km: 5.90, alt: 995 }, { km: 6.22, alt: 1002 },
    ],
  },
  {
    id: 65,
    name: 'Bodental',
    subtitle: 'Der Weg ins Bodental',
    shortDesc: 'Durch die Schlucht über den Tschaukofall hinauf ins idyllische Bodental zum Gasthof Kirchenwirt.',
    color: '#9575CD',
    totalKm: 5.44,
    poiCount: 30,
    highlights: ['Wasserüberlauf', 'Hohe Brücke', 'Tschaukofall', 'Felsentor', 'Bodental', 'Gasthof Kirchenwirt'],
    pois: [
      { id: 24752, name: 'Besucherzentrum', description: 'Das moderne Portal zur Schlucht — hier beginnt das Abenteuer.', type: 'manual', km: 0 },
      { id: 24804, name: 'Parkplatz', description: null, type: 'manual', km: 0.06 },
      { id: 24805, name: 'Flying Fox', description: 'Hoch über dem Loiblbach die Schlucht überqueren — Nervenkitzel pur.', type: 'manual', km: 0.35 },
      { id: 24710, name: 'Kassa', description: 'Die Schwelle zwischen der geordneten Welt und dem wilden Herzen des Berges.', type: 'manual', km: 1.26 },
      { id: 24719, name: 'Wasserüberlauf', description: 'Der Wasserüberlauf der Quelle, die ganz Ferlach mit Trinkwasser versorgt.', type: 'manual', km: 1.88 },
      { id: 26430, name: 'Hohe Brücke', description: 'Brücke über den engsten Abschnitt der Schlucht — tiefer Blick in die Felsspalten des Loiblbachs.', type: 'manual', km: 2.33 },
      // Name bewusst SO gelassen: das ist der Wegpunkt-Name aus ArTrack (wp
      // 24694). Diese Datei spiegelt die Quelle — sie hier umzubenennen hieße,
      // dass App und Daten verschiedene Namen für denselben Punkt führen. Ob
      // die Gabelung nach der Umwidmung anders heißen soll, ist eine
      // Datenfrage für ArTrack, keine Frontend-Frage.
      { id: 24694, name: 'Weggabelung - Wasserweg', description: 'Hier trennen sich die Routen — der Weg führt weiter hinauf Richtung Bodental.', type: 'manual', km: 2.62 },
      { id: 24720, name: 'Teufelsbrücke', description: 'Eine kühne Konstruktion über der tiefen Schlucht — schwindelerregend!', type: 'manual', km: 2.95 },
      { id: 26378, name: 'Tschaukofall', description: 'Der mächtige 26-Meter-Wasserfall — das Herzstück der Schlucht.', type: 'manual', km: 3.02 },
      { id: 26388, name: 'Felsentor', description: 'Ein Triumphbogen der Natur, über Jahrtausende vom Wasser geformt.', type: 'manual', km: 3.02 },
      { id: 26412, name: 'Weggabelung - Bodental', description: 'Am Rand des Bodentals öffnet sich der Blick auf stille Wiesen und die nahen Karawanken.', type: 'manual', km: 3.06 },
      { id: 24703, name: 'Gasthof Kirchenwirt', description: 'Traditionsgasthof im Bodental — der gemütliche Rastpunkt am Ziel der Route.', type: 'manual', km: 5.44 },
    ],
    elevation: [
      { km: 0.0, alt: 632 }, { km: 0.11, alt: 641 }, { km: 0.34, alt: 602 }, { km: 0.45, alt: 617 },
      { km: 0.55, alt: 588 }, { km: 0.8, alt: 602 }, { km: 1.05, alt: 614 }, { km: 1.33, alt: 610 },
      { km: 1.56, alt: 629 }, { km: 1.84, alt: 632 }, { km: 2.04, alt: 642 }, { km: 2.25, alt: 700 },
      { km: 2.29, alt: 722 }, { km: 2.34, alt: 737 }, { km: 2.38, alt: 737 }, { km: 2.41, alt: 758 },
      { km: 2.53, alt: 685 }, { km: 2.62, alt: 701 }, { km: 2.69, alt: 701 }, { km: 2.75, alt: 723 },
      { km: 2.89, alt: 750 }, { km: 2.94, alt: 798 }, { km: 2.97, alt: 792 }, { km: 3, alt: 792 },
      { km: 3.06, alt: 788 }, { km: 3.12, alt: 792 }, { km: 3.21, alt: 809 }, { km: 3.32, alt: 812 },
      { km: 3.4, alt: 813 }, { km: 3.63, alt: 876 }, { km: 3.72, alt: 874 }, { km: 3.79, alt: 867 },
      { km: 3.95, alt: 852 }, { km: 4.04, alt: 857 }, { km: 4.14, alt: 862 }, { km: 4.18, alt: 862 },
      { km: 4.27, alt: 892 }, { km: 4.35, alt: 892 }, { km: 4.41, alt: 892 }, { km: 4.56, alt: 924 },
      { km: 4.85, alt: 961 }, { km: 5.1, alt: 957 }, { km: 5.14, alt: 977 }, { km: 5.2, alt: 962 },
      { km: 5.36, alt: 949 }, { km: 5.44, alt: 953 },
    ],
  },
]

// Estimated walking time (4 km/h average, adjusted for gorge terrain)
export function estimateTime(km: number): string {
  // Kurzformen aus der aktiven Sprache — sonst stand „1 Std. 18 Min." unter
  // einer sonst englischen Route.
  return formatiereGehzeit((km / 3.5) * 60)
}
